import { render, staticRenderFns } from "./archive-table.vue?vue&type=template&id=e9efeb5e&scoped=true&"
import script from "./archive-table.vue?vue&type=script&lang=js&"
export * from "./archive-table.vue?vue&type=script&lang=js&"
import style0 from "./archive-table.vue?vue&type=style&index=0&id=e9efeb5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9efeb5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VPagination,VProgressLinear,VRow,VSelect,VTextField})
